import { Space, List, Card, Row, Col, Descriptions, Statistic, Divider } from "antd";
import { useAppSelector } from "../../../util/hooks";
import CountUp from "react-countup";
import "./style/index.scss";

const CaixaPainel = (props: any) => {
  //estados globais
  const painelGeralState = useAppSelector((state) => state.painelGeral);

  const formatter = (value: any) => <CountUp end={value} separator="." decimals={2} decimal="," />;

  return (
    <Space wrap align="start" className="spaceCaixa">
      <Divider orientation="left" orientationMargin="0" className="dividerCaixa">
        DESPESAS PENDENTES DE CONSIGNATARIOS
      </Divider>
      <List
        grid={{ gutter: 16 }}
        dataSource={painelGeralState.list}
        className="listPainel listCaixa listFin"
        renderItem={(item: any, index) => (
          <List.Item key={index}>
            <Card variant="borderless" className="cardPainel">
              <Row gutter={12}>
                <Col className="colPainel" span={24}>
                  <Descriptions title={`${props.titles[index]} (${item.quantidadePagar})`} layout="vertical" className="descriptionsPainel descriptionsCaixa" colon={false}>
                    <Descriptions.Item label="TOTAL R$">
                      <Statistic title="" value={item.totalPagar} formatter={formatter} />
                    </Descriptions.Item>
                  </Descriptions>
                </Col>
              </Row>
            </Card>
          </List.Item>
        )}
      />
    </Space>
  );
};

export default CaixaPainel;
